
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { STAT_COLUMNS, getColumnValue } from './explorerColumns';
import { getSuraColumn, getVerseColumn, getStatColumn } from './explorerFilters';
import ExplorerFilterInput from './ExplorerFilterInput.vue';

export default defineComponent({
  name: 'ExplorerTable',
  components: {
    ExplorerFilterInput,
  },
  props: {
    rows: { type: Array, required: true },
    sortKey: { type: String, required: true },
    sortAsc: { type: Boolean, required: true },
    showFilters: { type: Boolean, required: true },
    filterValues: { type: Object, required: true },
  },
  emits: ['sort', 'update-filter'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const sortBy = (key: string) => {
      emit('sort', key);
    };

    const updateFilter = (key: string, value: [number, number]) => {
      emit('update-filter', key, value);
    };

    const statColumns = computed(() => STAT_COLUMNS);
    const columnWidth = '6rem';
    const combinedSuraVerseWidth = '8rem';

    return {
      sortBy,
      updateFilter,
      statColumns,
      getColumnValue,
      columnWidth,
      combinedSuraVerseWidth,
      getSuraColumn,
      getVerseColumn,
      getStatColumn,
      t,
    };
  },
});
